/**
 * ClientV3Shell — light, mobile-first shell that wraps every V3 client page.
 *
 * Used by the multi-vendor client portal (/v/:slug/*) when the vendor's
 * preset is preset_3 (or always, since V3 is the dedicated client UI).
 *
 * Sets up:
 *   - .v3-root activator (overrides foreground to dark on light bg)
 *   - .v3-shell mobile-capped container (480px max width, centered)
 *   - sticky bottom navigation (Home / Games / Wallet / Inbox / Me)
 */
import { ClientV3BottomNav } from "@/presets/components/clientV3";

export default function ClientV3Shell({ children }) {
    return (
        <div className="v3-root" data-preset-shell="client_v3">
            <div className="v3-shell px-4 pt-5">{children}</div>
            <ClientV3BottomNav />
        </div>
    );
}
